var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingTouchUpTaskBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_4671)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.6167,
    y: -67.6068,
    width: 6,
    height: 113,
    transform: "rotate(45 56.6167 -67.6068)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.8594,
    y: -63.3641,
    width: 6,
    height: 113,
    transform: "rotate(45 60.8594 -63.3641)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.1021,
    y: -59.1215,
    width: 6,
    height: 113,
    transform: "rotate(45 65.1021 -59.1215)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.3447,
    y: -54.8788,
    width: 6,
    height: 113,
    transform: "rotate(45 69.3447 -54.8788)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.5872,
    y: -50.6362,
    width: 6,
    height: 113,
    transform: "rotate(45 73.5872 -50.6362)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8298,
    y: -46.3936,
    width: 6,
    height: 113,
    transform: "rotate(45 77.8298 -46.3936)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.0725,
    y: -42.1509,
    width: 6,
    height: 113,
    transform: "rotate(45 82.0725 -42.1509)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.3152,
    y: -37.9083,
    width: 6,
    height: 113,
    transform: "rotate(45 86.3152 -37.9083)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.5579,
    y: -33.6656,
    width: 6,
    height: 113,
    transform: "rotate(45 90.5579 -33.6656)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8005,
    y: -29.423,
    width: 6,
    height: 113,
    transform: "rotate(45 94.8005 -29.423)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.0432,
    y: -25.1804,
    width: 6,
    height: 113,
    transform: "rotate(45 99.0432 -25.1804)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.286,
    y: -20.9377,
    width: 6,
    height: 113,
    transform: "rotate(45 103.286 -20.9377)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.528,
    y: -16.6951,
    width: 6,
    height: 113,
    transform: "rotate(45 107.528 -16.6951)",
    fill: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.771,
    y: -12.4524,
    width: 6,
    height: 113,
    transform: "rotate(45 111.771 -12.4524)",
    fill: "#E2D0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.014,
    y: -8.20978,
    width: 6,
    height: 113,
    transform: "rotate(45 116.014 -8.20978)",
    fill: "#F2EAFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_4671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 16,
    fill: "white",
    transform: "translate(0.714355 0.0700073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTouchUpTaskBackground);
export default __webpack_public_path__ + "static/media/pending-touch-up-task-background.0e349f00256ecfbb3df72987f7e3ad57.svg";
export { ForwardRef as ReactComponent };